import { realApi } from './api';

// Solo ADMIN (el backend responde 403 al resto).
export const getUsuarios = () => realApi.get('/usuarios').then((r) => r.datos);

// Devuelve { usuario, contrasenaTemporal, correo: { enviado, error } }. La
// contraseña solo se ve en esta respuesta: la BD guarda únicamente el hash.
export const crearUsuario = (datos) => realApi.post('/usuarios', datos).then((r) => r.datos);

// cambio: { rol?, jugadorId?, activo? }
export const actualizarUsuario = (id, cambio) => realApi.patch(`/usuarios/${id}`, cambio).then((r) => r.datos);

// Restablece la contraseña (temporal, a cambiar en el primer acceso) y la manda por correo.
export const enviarAcceso = (id) => realApi.post(`/usuarios/${id}/enviar-acceso`).then((r) => r.datos);

// Jugadores que aún no tienen usuario (solo ellos se pueden vincular): [{ id, nombre, email }].
export const getJugadoresSinUsuario = () => realApi.get('/usuarios/jugadores-sin-usuario').then((r) => r.datos);

// Correo de acceso tal como se enviará al crear: { asunto, texto }.
export const getVistaPreviaAcceso = (usuario, jugadorId) => {
  const params = new URLSearchParams({ usuario });
  if (jugadorId) params.set('jugadorId', jugadorId);
  return realApi.get(`/usuarios/vista-previa-acceso?${params}`).then((r) => r.datos);
};
